'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _text = require('@hixme-ui/text');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Time = _text.TextBase.withComponent('time');

var ReadableDatetime = function (_Component) {
  (0, _inherits3.default)(ReadableDatetime, _Component);

  function ReadableDatetime() {
    (0, _classCallCheck3.default)(this, ReadableDatetime);
    return (0, _possibleConstructorReturn3.default)(this, (ReadableDatetime.__proto__ || (0, _getPrototypeOf2.default)(ReadableDatetime)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReadableDatetime, [{
    key: 'getTime',

    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTimezoneOffset
    // The time-zone offset is the difference, in minutes, between UTC and local time.
    // Note that this means that the offset is positive if the local timezone is behind
    // UTC and negative if it is ahead.
    value: function getTime() {
      var _props = this.props,
          datetime = _props.datetime,
          format = _props.format;


      var offset = -new Date().getTimezoneOffset();
      return _moment2.default.utc(datetime).utcOffset(offset).format(format);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          datetime = _props2.datetime,
          format = _props2.format,
          rest = (0, _objectWithoutProperties3.default)(_props2, ['datetime', 'format']);

      return _react2.default.createElement(
        Time,
        rest,
        this.getTime()
      );
    }
  }]);
  return ReadableDatetime;
}(_react.Component);

ReadableDatetime.propTypes = {
  datetime: _propTypes2.default.string.isRequired,
  format: _propTypes2.default.string
};

ReadableDatetime.defaultProps = {
  format: 'MM/DD/YYYY h:mm:ss a'
};

ReadableDatetime.displayName = 'ReadableDatetime';
ReadableDatetime.huiName = 'hui:ReadableDatetime';

exports.default = ReadableDatetime;
//# sourceMappingURL=ReadableDatetime.js.map


//////////////////
// WEBPACK FOOTER
// ../dates/lib/ReadableDatetime/ReadableDatetime.js
// module id = 696
// module chunks = 0